import clsx from 'clsx';
import type { ButtonHTMLAttributes } from 'react';
import { SendHorizontal } from 'lucide-react';

/**
 * t208u: the one send button for composers. On a phone it is a 44px brand-yellow square (48px tap target via the
 * invisible outset) with a black ~21px icon; when there is nothing to send it stays in place but muted (grey, icon at 40%).
 */
export function SendButton({ phone, className, label = 'Send', ...rest }: ButtonHTMLAttributes<HTMLButtonElement> & { phone?: boolean; label?: string }) {
  return (
    <button type="button" title={label} aria-label={label} {...rest}
      className={clsx('relative flex shrink-0 items-center justify-center bg-accent text-on-accent-strong ring-1 ring-inset ring-black/10 transition hover:bg-accent-hover',
        'disabled:bg-slate-200 disabled:ring-0 dark:disabled:bg-slate-800 dark:disabled:text-slate-200 [&:disabled>svg]:opacity-40',
        phone ? "h-11 w-11 rounded-xl before:absolute before:-inset-0.5 before:content-['']" : 'h-8 w-8 rounded-lg', className)}>
      <SendHorizontal aria-hidden className={phone ? 'h-[21px] w-[21px]' : 'h-4 w-4'} />
    </button>
  );
}
